import { Injectable } from '@angular/core';
import {Functions, httpsCallable} from "@angular/fire/functions";
import { CommentsService } from './comments.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, map } from 'rxjs';
import { NetworkConstants } from 'na-lib';
import { FirestoreService } from './firestore.service';
import { collection, collectionData, doc, docData, getDocs, query, where } from '@angular/fire/firestore';
import { SettingsService } from './settings.service';


@Injectable({
  providedIn: 'root'
})
export class AdvancedExperiencesService {
  existingUrlPrefixes: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([])//any=[]
  existingCoverImages: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([])//any
  settingsAdvancedExperiences = []
  settingsAdvancedExperienceNFC = undefined
  settingsAdvancedExperiencesAppStoreId = {}

  db = this.firestoreDB.db//getFirestore()

  constructor(
    private firestoreDB:FirestoreService,
    private functions: Functions,
    private commentService:CommentsService,
    private translate:TranslateService,
    private settingsService: SettingsService
  ) { }

  async getActualUrlPrefixes(showProgress = true): Promise<void> {
    if (showProgress) this.commentService.progressSpin.emit(true);
    const createExperience = httpsCallable(this.functions, 'appStoreConnect-requestExperiences');
    try {
      const result = await createExperience();
      const data = result.data as any;
      this.existingCoverImages.next(data.data);

      const links = data.data.map(cover => cover.link);
      this.existingUrlPrefixes.next(links);
    } catch (error) {
      console.log(error);
      const message = this.translate.instant("SnackBarConstants.CREATE_FAILED");
      this.commentService.addSnackBar.emit(message);
      this.commentService.addSnackBar.emit(error);
    } finally {
      if (showProgress) this.commentService.progressSpin.emit(false);
    }
  }

  async getCoverImagesWithNFCPrefix(nfcPrefix: string) {

    const contextId$ = this.settingsService.contextId$
    const ref = collection (this.db, `${NetworkConstants.COLLECTION_ADVANCED_EXPERIENCES}`);
    const q = query (ref,  where("contextId", '==',contextId$, ), 
                      // where("urlPrefix", "==", nfcPrefix)
                    );
    const snapshot = await getDocs(q);
    const res = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    let found: any | null = null;

    res.forEach((data:any) => {
      if (data.urlPrefix === nfcPrefix) {
        if (data.appStoreImageURL) {
          const w = "282";
          const h = "171";
          const c = "bb";
          const f = "png";

          data.imageUrl = decodeURI(data.appStoreImageURL)
            .replaceAll("{w}", w)
            .replaceAll("{h}", h)
            .replaceAll("{c}", c)
            .replaceAll("{f}", f);
        }
        found = data;
      }
    });

    return found
  }


  async getCoverImagesWithAppStoreId(appStoreId){
    this.settingsAdvancedExperiencesAppStoreId = {}

    const contextId$ = this.settingsService.contextId$
    const aeRef = collection(this.db, NetworkConstants.COLLECTION_ADVANCED_EXPERIENCES);
    const q = query( aeRef, where('appStoreId', '==', appStoreId) );
    const docs = await getDocs(q);

    docs.forEach((doc) => {
      const data: any = { id: doc.id, ...doc.data() };
  
      if (data.contextId === contextId$) {
        if (data.appStoreImageURL) {
          data.imageUrl = decodeURI(data.appStoreImageURL)
            .replaceAll('{w}', '282') .replaceAll('{h}', '171')
            .replaceAll('{c}', 'bb').replaceAll('{f}', 'png');
        }
        this.settingsAdvancedExperiencesAppStoreId = data;
      }
    });

    return this.settingsAdvancedExperiencesAppStoreId
  }

  observeAdvancedExperiencesFirestore(){
    this.settingsAdvancedExperiences = []

    const contextId$ = this.settingsService.contextId$
    const ref = collection (this.db, `${NetworkConstants.COLLECTION_ADVANCED_EXPERIENCES}`);
    const q = query (ref,  where("contextId", '==',contextId$, ), 
                      // where("urlPrefix", "==", nfcPrefix)
                    );
      return collectionData(q, { idField: 'id' }).pipe(
        map((worktasks: any[]) =>
          worktasks.map((data) => {
            if (data.app) {
              const w="282"
              const h="171"
              const c="bb"
              const f="png"
              const appStoreImageURL = data['appStoreImageURL']
              data['imageUrl'] = decodeURI(appStoreImageURL).replaceAll("{w}", w).replaceAll("{h}", h).replaceAll("{c}", c).replaceAll("{f}", f)
            }
            return data;
          })
        )
      );

  }

  observeAdvancedExperiencesIdFirestore(ae_id:string){
    const docRef = doc(this.db, `${NetworkConstants.COLLECTION_ADVANCED_EXPERIENCES}/${ae_id}`);
    return docData(docRef);
  }
}